import { createStyles, Grid, TextField, Theme, withStyles, WithStyles } from '@material-ui/core'
import * as React from 'react'

interface TrainingHoursProps extends WithStyles<typeof styles> {
	trainingHours: string | number
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const TrainingHours: React.FC<TrainingHoursProps> = (props: TrainingHoursProps) => {
	const { classes, onChange, trainingHours } = props

	return (
		<Grid container={true} spacing={8}>
			<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
				Total Training Hours&#58;
			</Grid>

			<Grid item={true} xs={12} md={2}>
				<TextField
					name="trainingHours"
					className={classes.dropdown}
					value={trainingHours}
					onChange={onChange}
					margin="dense"
					variant="outlined"
					type="number"
					InputProps={{
						inputProps: {
							type: 'number',
							min: '0',
							step: '0.01',
						},
					}}
				/>
			</Grid>
		</Grid>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
	})

export default withStyles(styles)(TrainingHours)
